import React from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-white text-slate-600 border-t border-slate-200 pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-6 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">
        {/* Brand Column */}
        <div className="space-y-4">
          <div className="flex items-center gap-3">
            <img
              src="https://assets.auxodev.dk/assets/d1f69564-4a06-4909-b6f1-fa1f6ad6911e/logo.png"
              alt="Tømrerfirmaet RNS - Glatvedvej 28, 8444 Balle på Djursland"
              className="h-12 sm:h-16 w-auto object-contain"
            />
          </div>
        </div>

        {/* Services Column */}
        <div>
          <h4 className="font-display font-semibold text-slate-900 mb-4 text-sm uppercase tracking-wider">
            Vores Ydelser
          </h4>
          <ul className="space-y-2.5 text-sm">
            <li>
              <Link to="/ydelser/toemrer" className="hover:text-brand-primary transition-colors">
                Tømrerarbejde
              </Link>
            </li>
            <li>
              <Link to="/ydelser/maler" className="hover:text-brand-primary transition-colors">
                Malerarbejde
              </Link>
            </li>
            <li>
              <Link to="/ydelser/sommerhusrenovering" className="hover:text-brand-primary transition-colors">
                Sommerhusrenovering
              </Link>
            </li>
            <li>
              <Link to="/ydelser/asbestarbejde-og-tagrenovering" className="hover:text-brand-primary transition-colors">
                Nyt tag
              </Link>
            </li>
            <li>
              <Link to="/ydelser/udskiftning-af-vinduer" className="hover:text-brand-primary transition-colors">
                Udskiftning af vinduer og døre
              </Link>
            </li>
          </ul>
        </div>

        {/* Quick Links Column */}
        <div>
          <h4 className="font-display font-semibold text-slate-900 mb-4 text-sm uppercase tracking-wider">
            Hurtige Links
          </h4>
          <ul className="space-y-2.5 text-sm">
            <li>
              <Link to="/" className="hover:text-brand-primary transition-colors">
                Forside
              </Link>
            </li>
            <li>
              <Link to="/om-os" className="hover:text-brand-primary transition-colors">
                Hvem er vi
              </Link>
            </li>
            <li>
              <Link to="/referencer" className="hover:text-brand-primary transition-colors">
                Projekter
              </Link>
            </li>
            <li>
              <Link to="/galleri" className="hover:text-brand-primary transition-colors">
                Galleri
              </Link>
            </li>
            <li>
              <Link to="/kontakt" className="hover:text-brand-primary transition-colors">
                Kontakt os
              </Link>
            </li>
          </ul>
        </div>

        {/* Contact Column */}
        <div>
          <h4 className="font-display font-semibold text-slate-900 mb-4 text-sm uppercase tracking-wider">
            Kontaktoplysninger
          </h4>
          <ul className="space-y-3 text-sm">
            <li className="flex items-start gap-3">
              <i className="fa-solid fa-location-dot text-brand-primary mt-1" />
              <span className="leading-relaxed">
                Glatvedvej 28<br />
                8444 Balle
              </span>
            </li>
            <li className="flex items-center gap-3">
              <i className="fa-solid fa-phone text-brand-primary" />
              <a href="tel:22439147" className="hover:text-brand-primary transition-colors whitespace-nowrap">
                +45 22 43 91 47
              </a>
            </li>
            <li className="flex items-center gap-3">
              <i className="fa-solid fa-envelope text-brand-primary" />
              <a href="mailto:trns@mail.dk" className="hover:text-brand-primary transition-colors whitespace-nowrap">
                trns@mail.dk
              </a>
            </li>
            <li className="flex items-center gap-3 pt-2 border-t border-slate-200">
              <span className="text-xs text-slate-400">
                CVR-nr: 36083131
              </span>
            </li>
          </ul>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="max-w-7xl mx-auto px-6 pt-8 border-t border-slate-200 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-slate-400">
        <p>© {currentYear} Tømrerfirmaet RNS. Alle rettigheder forbeholdes.</p>
        <div className="flex items-center gap-4 flex-wrap justify-center">
          <a
            href="https://www.iubenda.com/privacy-policy/76664868"
            className="iubenda-white iubenda-noiframe iubenda-embed hover:underline"
            title="Privatlivspolitik "
          >
            Privatlivspolitik
          </a>
          <a
            href="https://www.iubenda.com/privacy-policy/76664868/cookie-policy"
            className="iubenda-white iubenda-noiframe iubenda-embed hover:underline"
            title="Cookiepolitik "
          >
            Cookiepolitik
          </a>
          <a
            href="https://www.facebook.com/tomrerrns"
            target="_blank"
            rel="noopener noreferrer"
            className="text-black hover:text-black/70 text-lg transition-colors"
            aria-label="Følg os på Facebook"
          >
            <i className="fa-brands fa-facebook" />
          </a>
        </div>
      </div>
    </footer>
  );
}
